import request from "@/utils/request";
import { apiConfig } from "../config/api";

//请求资源树
export function getAdminResources() {
  return request({
    url: apiConfig.adminResource.api.search.url,
    method: "get"
  });
}

//新增资源
export function addAdminResource(resource) {
  return request({
    url: apiConfig.adminResource.api.add.url,
    method: "post",
    data: {
      resourceName: resource.resourceName,
      resourceDesc: resource.resourceDesc,
      resourceTypeCode: resource.resourceTypeCode,
      parentId: resource.parentId,
      path: resource.path,
      icon: resource.icon,
      sort: resource.sort,
      operators: resource.operators
    }
  });
}

//更新资源
export function updateAdminResource(resource) {
  return request({
    url: apiConfig.adminResource.api.update.url,
    method: "post",
    data: {
      id: resource.id,
      resourceName: resource.resourceName,
      resourceDesc: resource.resourceDesc,
      resourceTypeCode: resource.resourceTypeCode,
      parentId: resource.parentId,
      path: resource.path,
      icon: resource.icon,
      sort: resource.sort,
      operators: resource.operators
    }
  });
}

//删除资源
export function deleteAdminResource(id) {
  return request({
    url: apiConfig.adminResource.api.delete.url,
    method: "post",
    params: {
      id: id
    }
  });
}
